export const PASSSTATUSES = [
    {
        label: 'DDL_ACTIVE',
        value: 0
    },
    {
        label: 'DDL_INACTIVE',
        value: 1
    },
    {
        label: 'DDL_ALL',
        value: 2
    }
]


